/**
 * @generated SignedSource<<b71bea97dcccd9ea55830e29fae961b9>>
 * @relayHash 19abeaf03278462751d1cf808a3f00f5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 19abeaf03278462751d1cf808a3f00f5

import type { ConcreteRequest } from 'relay-runtime';
export type ReplaceActorsForAssignableInput = {
  actorIds?: ReadonlyArray<string> | null | undefined;
  actorLogins?: ReadonlyArray<string> | null | undefined;
  agentAssignment?: AgentAssignmentInput | null | undefined;
  assignableId: string;
  clientMutationId?: string | null | undefined;
};
export type AgentAssignmentInput = {
  baseRef?: string | null | undefined;
  customAgent?: string | null | undefined;
  customInstructions?: string | null | undefined;
  model?: string | null | undefined;
  targetRepositoryId?: string | null | undefined;
};
export type replaceActorsForAssignableRelayMutation$variables = {
  input: ReplaceActorsForAssignableInput;
};
export type replaceActorsForAssignableRelayMutation$data = {
  readonly replaceActorsForAssignable: {
    readonly assignable: {
      readonly agentAssignments?: ReadonlyArray<{
        readonly assignee: {
          readonly avatarUrl: string;
          readonly displayName: string;
          readonly id: string;
          readonly isAgent: boolean;
          readonly isCopilot: boolean;
          readonly login: string;
        } | null | undefined;
        readonly assigner: {
          readonly login?: string;
        } | null | undefined;
      }>;
      readonly assignedActors?: {
        readonly nodes: ReadonlyArray<{
          readonly __typename?: string;
          readonly avatarUrl?: string;
          readonly displayName?: string;
          readonly id?: string;
          readonly isAgent?: boolean;
          readonly isCopilot?: boolean;
          readonly login?: string;
          readonly name?: string | null | undefined;
          readonly profileResourcePath?: string | null | undefined;
        } | null | undefined> | null | undefined;
      };
      readonly id?: string;
      readonly participants?: {
        readonly nodes: ReadonlyArray<{
          readonly avatarUrl: string;
          readonly id: string;
          readonly login: string;
          readonly name: string | null | undefined;
          readonly profileResourcePath: string | null | undefined;
        } | null | undefined> | null | undefined;
      };
    } | null | undefined;
  } | null | undefined;
};
export type replaceActorsForAssignableRelayMutation$rawResponse = {
  readonly replaceActorsForAssignable: {
    readonly assignable: {
      readonly __typename: "Issue";
      readonly __isNode: "Issue";
      readonly agentAssignments: ReadonlyArray<{
        readonly assignee: {
          readonly avatarUrl: string;
          readonly displayName: string;
          readonly id: string;
          readonly isAgent: boolean;
          readonly isCopilot: boolean;
          readonly login: string;
        } | null | undefined;
        readonly assigner: {
          readonly __typename: "Bot";
          readonly id: string;
          readonly login: string;
        } | {
          readonly __typename: "User";
          readonly id: string;
          readonly login: string;
        } | {
          readonly __typename: string;
          readonly id: string;
        } | null | undefined;
      }>;
      readonly assignedActors: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "Bot";
          readonly __isActor: "Bot";
          readonly __isNode: "Bot";
          readonly avatarUrl: string;
          readonly displayName: string;
          readonly id: string;
          readonly isAgent: boolean;
          readonly isCopilot: boolean;
          readonly login: string;
          readonly name: string | null | undefined;
          readonly profileResourcePath: string | null | undefined;
        } | {
          readonly __typename: string;
          readonly __isActor: string;
          readonly __isNode: string;
          readonly avatarUrl: string;
          readonly id: string;
          readonly login: string;
          readonly name: string | null | undefined;
          readonly profileResourcePath: string | null | undefined;
        } | null | undefined> | null | undefined;
      };
      readonly id: string;
      readonly participants: {
        readonly nodes: ReadonlyArray<{
          readonly avatarUrl: string;
          readonly id: string;
          readonly login: string;
          readonly name: string | null | undefined;
          readonly profileResourcePath: string | null | undefined;
        } | null | undefined> | null | undefined;
      };
    } | {
      readonly __typename: string;
      readonly __isNode: string;
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type replaceActorsForAssignableRelayMutation = {
  rawResponse: replaceActorsForAssignableRelayMutation$rawResponse;
  response: replaceActorsForAssignableRelayMutation$data;
  variables: replaceActorsForAssignableRelayMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileResourcePath",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Bot",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v5/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v14 = [
  (v5/*: any*/)
],
v15 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "User",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "Bot",
  "abstractKey": null
},
v17 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    }
  ],
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "participants",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "participants(first:10)"
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "replaceActorsForAssignableRelayMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReplaceActorsForAssignablePayload",
        "kind": "LinkedField",
        "name": "replaceActorsForAssignable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "assignable",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": (v3/*: any*/),
                    "concreteType": "AssigneeConnection",
                    "kind": "LinkedField",
                    "name": "assignedActors",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v4/*: any*/),
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v12/*: any*/)
                            ],
                            "type": "Actor",
                            "abstractKey": "__isActor"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "assignedActors(first:20)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgentAssignment",
                    "kind": "LinkedField",
                    "name": "agentAssignments",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "assigner",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/)
                ],
                "type": "Issue",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "replaceActorsForAssignableRelayMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReplaceActorsForAssignablePayload",
        "kind": "LinkedField",
        "name": "replaceActorsForAssignable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "assignable",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": (v3/*: any*/),
                    "concreteType": "AssigneeConnection",
                    "kind": "LinkedField",
                    "name": "assignedActors",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v12/*: any*/)
                            ],
                            "type": "Actor",
                            "abstractKey": "__isActor"
                          },
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "assignedActors(first:20)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgentAssignment",
                    "kind": "LinkedField",
                    "name": "agentAssignments",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "assigner",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v17/*: any*/)
                ],
                "type": "Issue",
                "abstractKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "19abeaf03278462751d1cf808a3f00f5",
    "metadata": {},
    "name": "replaceActorsForAssignableRelayMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d05c4cf0e56aab9d1e1f20b1139e9c19";

export default node;
